


























import { Component, Vue } from 'vue-property-decorator';
import { wlPath } from '@/lib/Whitelabel';

@Component
export default class Splash extends Vue {

  // reactive properties

  // injected properties

  // non-reactive properties

  // lifecycle

  // computed
  get whitelabelPath(): string {
    return wlPath;
  }

  // methods

}

